import React from 'react';
import PropTypes from 'prop-types';
import { dealStatusView } from '../../utils/dealStatus';
import { Tooltip } from '../ui';

// Chip classes per tone: Sale pending / Pre-sold amber, Sold grey, On hold an
// amber outline (blocked, not a deal), Quoted a teal outline, Available plain
// muted text (decisions/inventory-columns.md).
const TONE_CLASS = {
    pending: 'v2-chip v2-chip--warn inv2-deal',
    sold: 'v2-chip v2-chip--neutral inv2-deal',
    hold: 'v2-chip inv2-deal inv2-deal--hold',
    quoted: 'v2-chip inv2-deal inv2-deal--quoted',
    available: 'inv2-muted inv2-deal-avail',
};

/**
 * A unit's deal status. The tooltip carries the meaning in words, so the
 * state never relies on colour; it is the ui Tooltip (hover, keyboard focus,
 * tap; aria-describedby), not a title, so keyboard and touch users reach it
 * too. Committed statuses also show their date, with the year when it is
 * not this year (QA E6); `withVerb` names it ("marked sold Sep 22",
 * "invoiced Dec 3, 2025"), as the unit preview does. On hold has no date;
 * its tooltip carries the reason. No shown status (missing, unknown): a
 * muted dash.
 */
export default function DealStatusChip({ unit, withVerb = false }) {
    const view = dealStatusView(unit);
    if (!view) return <span className="inv2-muted">—</span>;
    const dateLabel = withVerb ? view.dateText : view.shortDate;
    return (
        <span className="inv2-deal-cell" data-status={view.status}>
            {view.tip ? (
                <Tooltip content={view.tip}>
                    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
                    <span className={TONE_CLASS[view.tone]} tabIndex={0}>{view.label}</span>
                </Tooltip>
            ) : (
                <span className={TONE_CLASS[view.tone]}>{view.label}</span>
            )}
            {dateLabel && <span className="inv2-deal-date">{dateLabel}</span>}
        </span>
    );
}

DealStatusChip.propTypes = {
    unit: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    withVerb: PropTypes.bool,
};
